// import React, { useState, useEffect } from "react";

// import neoNeckImage from "assets/images/superHuman/neoNeckImage.png";
// import neoTodoList from "assets/images/superHuman/neoTodoList.webp";
// import groupDiscussion from "assets/images/superHuman/groupDiscussion.png";
// import accountVerification from "assets/images/superHuman/accountVerification.webp";
// import blackNeoNeck from "assets/images/superHuman/blackNeoNeck.png";
// import memories from "assets/images/superHuman/memories.webp";
// import twoPeopleNeo from "assets/images/superHuman/twoPeopleNeo.png";
// import accountVerificationLoop from "assets/images/superHuman/accountVerificationLoop.webp";

// import neoNeckImageMobile from "assets/images/superHuman/neoNeckImageMobile.png";
// import groupDiscussionMobile from "assets/images/superHuman/groupDiscussionMobile.png";
// import blackNeoNeckMobile from "assets/images/superHuman/blackNeoNeckMobile.png";
// import twoPeopleNeoMobile from "assets/images/superHuman/twoPeopleNeoMobile.png";

// import neoNeckImageTab from "assets/images/superHuman/neoNeckImageTab.webp";
// import groupDiscussionTab from "assets/images/superHuman/groupDiscussionTab.webp";
// import blackNeoNeckTab from "assets/images/superHuman/blackNeoNeckTab.webp";
// import twoPeopleNeoTab from "assets/images/superHuman/twoPeopleNeoTab.webp";

// import one from "assets/images/superHuman/brainStorming.webp";
// import two from "assets/images/superHuman/smartMeeting.webp";
// import three from "assets/images/superHuman/infiniteMemory.webp";
// import four from "assets/images/superHuman/readBetween.webp";

// import "./superHuman.scss";
// import useScreenMobile from "hooks/useScreenMobile";
// import FadeUp from "component/FadeUp/FadeUp";

// const superHumanData = [
//   {
//     id: 1,
//     title: "Your Best Brainstorming Partner.",
//     description:
//       "Get instant personalised answers, and use Neo 1 AI assistant to clarify, brainstorm, and explore ideas from your conversations. Brainstorm with the best collaborator who knows you.",
//     imgSrc: neoTodoList,
//     mobileSrc: one,
//     backgroundImage: neoNeckImage,
//     mobileImage: neoNeckImageMobile,
//     tabImage: neoNeckImageTab
//   },
//   {
//     id: 2,
//     title: "Smarter Meetings, Zero Effort.",
//     description:
//       "Stay on top of every detail. Neo 1 keeps track of everything for you. Stay organized, stay sharp, and forget about taking notes forever.",
//     imgSrc: accountVerification,
//     mobileSrc: two,
//     backgroundImage: groupDiscussion,
//     mobileImage: groupDiscussionMobile,
//     tabImage: groupDiscussionTab
//   },
//   {
//     id: 3,
//     title: "Infinite Memory That Works Like Magic.",
//     description:
//       "Every conversation, every detail, always at your fingertips. Neo 1 keeps your memories alive and accessible.",
//     imgSrc: memories,
//     mobileSrc: three,
//     backgroundImage: blackNeoNeck,
//     mobileImage: blackNeoNeckMobile,
//     tabImage: blackNeoNeckTab
//   },
//   {
//     id: 4,
//     title: "Read Between The Lines.",
//     description:
//       "Let Neo 1 reveal the tone and emotions behind your words. Communicate with confidence, build trust, and amplify your influence.",
//     imgSrc: accountVerificationLoop,
//     mobileSrc: four,
//     backgroundImage: twoPeopleNeo,
//     mobileImage: twoPeopleNeoMobile,
//     tabImage: twoPeopleNeoTab
//   }
// ];

// const SuperHuman = () => {
//   const isMobile = useScreenMobile({ size: 767 });
//   const isTab = useScreenMobile({ size: 1024 });

//   const [scrollEffect, setScrollEffect] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 200) {
//         setScrollEffect(true);
//       } else {
//         setScrollEffect(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <>
//       <section className="container superHumanContainer ">
//         <div className="common-heading superHumanHeading">
//           <h1 className="topToBottom">superhuman starts here</h1>

//           <FadeUp>
//             <p className="superHumanContent ">
//               Get Neo 1 and unlock the power of your second brain.
//             </p>
//           </FadeUp>
//         </div>

//         <div
//           className={`superHumanData ${scrollEffect ? "scroll-effect" : ""}`}
//         >
//           {superHumanData.map((item, index) => (
//             <div
//               key={index}
//               className="card"
//               style={{
//                 backgroundImage: `url(${
//                   isMobile
//                     ? item.mobileImage
//                     : isTab
//                       ? item.tabImage
//                       : item.backgroundImage
//                 })`,
//                 backgroundRepeat: "no-repeat",
//                 backgroundSize: "100% 100%"
//               }}
//             >
//               <div className="cardContent">
//                 <FadeUp>
//                   <h3>{item.title}</h3>
//                 </FadeUp>

//                 <p>{item.description}</p>
//               </div>
//               {!isMobile && (
//                 <div className="card-img">
//                   <img
//                     src={item.imgSrc}
//                     alt={item.title}
//                     className="cardImage"
//                   />
//                 </div>
//               )}
//               {isMobile && (
//                 <div className="card-img">
//                   <img
//                     src={item.mobileSrc}
//                     //   alt={item.title}
//                     className="cardImage"
//                   />
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </section>
//     </>
//   );
// };

// export default SuperHuman;

import React, { useState, useEffect } from "react";

import neoNeckImage from "assets/images/superHuman/neoNeckImage.webp";
import neoTodoList from "assets/images/superHuman/neoTodoList.webp";
import groupDiscussion from "assets/images/superHuman/groupDiscussion.webp";
import accountVerification from "assets/images/superHuman/accountVerification.webp";
import blackNeoNeck from "assets/images/superHuman/blackNeoNeck.webp";
import memories from "assets/images/superHuman/memories.webp";
import twoPeopleNeo from "assets/images/superHuman/twoPeopleNeo.webp";
import accountVerificationLoop from "assets/images/superHuman/accountVerificationLoop.webp";

import neoNeckImageMobile from "assets/images/superHuman/neoNeckImageMobile.png";
import groupDiscussionMobile from "assets/images/superHuman/groupDiscussionMobile.png";
import blackNeoNeckMobile from "assets/images/superHuman/blackNeoNeckMobile.png";
import twoPeopleNeoMobile from "assets/images/superHuman/twoPeopleNeoMobile.png";

import neoNeckImageTab from "assets/images/superHuman/neoNeckImageTab.webp";
import groupDiscussionTab from "assets/images/superHuman/groupDiscussionTab.webp";
import blackNeoNeckTab from "assets/images/superHuman/blackNeoNeckTab.webp";
import twoPeopleNeoTab from "assets/images/superHuman/twoPeopleNeoTab.webp";

import one from "assets/images/superHuman/effortless.mp4";
import two from "assets/images/superHuman/smarter-meetings.mp4";
import three from "assets/images/superHuman/staysharp.mp4";
import four from "assets/images/superHuman/justiq.mp4";

import "./superHuman.scss";
import useScreenMobile from "hooks/useScreenMobile";
import FadeUp from "component/FadeUp/FadeUp";

const superHumanData = [
  {
    id: 1,
    title: "Your Best Brainstorming Partner.",
    description:
      "Get instant personalised answers, and use Neo 1 AI assistant to clarify, brainstorm, and explore ideas from your conversations. Brainstorm with the best collaborator who knows you.",
    imgSrc: neoTodoList,
    mobileSrc: one,
    backgroundImage: neoNeckImage,
    mobileImage: neoNeckImageMobile,
    tabImage: neoNeckImageTab
  },
  {
    id: 2,
    title: "Smarter Meetings, Zero Effort.",
    description:
      "Stay on top of every detail. Neo 1 keeps track of everything for you. Stay organized, stay sharp, and forget about taking notes forever.",
    imgSrc: accountVerification,
    mobileSrc: two,
    backgroundImage: groupDiscussion,
    mobileImage: groupDiscussionMobile,
    tabImage: groupDiscussionTab
  },
  {
    id: 3,
    title: "Infinite Memory That Works Like Magic.",
    description:
      "Every conversation, every detail, always at your fingertips. Neo 1 keeps your memories alive and accessible.",
    imgSrc: memories,
    mobileSrc: three,
    backgroundImage: blackNeoNeck,
    mobileImage: blackNeoNeckMobile,
    tabImage: blackNeoNeckTab
  },
  {
    id: 4,
    title: "Not Just IQ, Elevate Your EQ",
    description:
      "Leverage Neo 1’s emotion analysis to decode conversations, gain insights, and refine your emotional intelligence. Build stronger relationships, lead with empathy, and influence with confidence. Because great communication starts with understanding emotions.",
    imgSrc: accountVerificationLoop,
    mobileSrc: four,
    backgroundImage: twoPeopleNeo,
    mobileImage: twoPeopleNeoMobile,
    tabImage: twoPeopleNeoTab
  }
];

const SuperHuman = () => {
  const isMobile = useScreenMobile({ size: 767 });
  const isTab = useScreenMobile({ size: 1024 });

  const [scrollEffect, setScrollEffect] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!isMobile) {
        if (window.scrollY > 200) {
          setScrollEffect(true);
        } else {
          setScrollEffect(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className="container superHumanContainer ">
        <div className="common-heading superHumanHeading">
          <h1 className="topToBottom">superhuman starts here</h1>

          <FadeUp>
            <p className="superHumanContent">
              Get your Neo 1 and level up to Mind 2.0.
            </p>
          </FadeUp>
        </div>

        <div
          className={`superHumanData ${scrollEffect ? "scroll-effect" : ""}`}
        >
          {superHumanData.map((item, index) => {
            if (!isMobile) {
              return (
                <div
                  key={index}
                  className="card"
                  style={{
                    backgroundImage: `url(${
                      isMobile
                        ? item.mobileImage
                        : isTab
                          ? item.tabImage
                          : item.backgroundImage
                    })`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%"
                  }}
                >
                  <div className="cardContent">
                    <FadeUp>
                      <h3>{item.title}</h3>
                    </FadeUp>

                    <p>{item.description}</p>
                  </div>
                  {!isMobile && (
                    <div className="card-img">
                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        src={item.mobileSrc}
                        alt={item.title}
                        className="cardImage"
                      />
                    </div>
                  )}
                </div>
              );
            }
            if (isMobile) {
              return (
                <div
                  key={index}
                  className="card"
                  style={{
                    backgroundImage: `url(${
                      isMobile
                        ? item.mobileImage
                        : isTab
                          ? item.tabImage
                          : item.backgroundImage
                    })`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%"
                  }}
                >
                  <div className="cardContent">
                    <FadeUp>
                      <h3>{item.title}</h3>
                    </FadeUp>

                    <p>{item.description}</p>
                  </div>

                  <div className="card-img">
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      src={item.mobileSrc}
                      //   alt={item.title}
                      className="cardImage"
                    />
                  </div>
                </div>
              );
            }
          })}
        </div>
      </section>
    </>
  );
};

export default SuperHuman;
